export default "__VITE_ASSET__DFRvz$Ru__"